<template>
  <span>
    <user-avatar
      :size="size"
      :user="item"
      v-for="(item, index) in _.take(users, limit)"
      :key="item.id"
      :cssClass="index < users.length - 1 ? `mr-n${overlap}` : ''"
      :borderColor="dark ? 'white' : 'secondary'"
      v-on:click="$emit('click')"
    ></user-avatar>
    <v-avatar
      :size="size"
      :color="dark ? 'white' : 'secondary'"
      v-if="users.length > limit"
      :class="{ 'white--text': !dark, 'secondary--text': dark }"
      @click="$emit('click')"
    >
      +{{ users.length - limit }}
    </v-avatar>
  </span>
</template>

<script>
export default {
  name: "OverlapAvatars",
  props: {
    users: { type: Array },
    size: { type: Number, default: 40 },
    limit: { type: Number, default: 4 },
    overlap: { type: Number, default: 2 },
    dark: { type: Boolean, default: false }
  },
  data: () => ({})
};
</script>
